import { css } from '@emotion/core';
export var anchor = {
  name: "1gomreu",
  styles: "position:relative;display:inline-block;"
};
var _ref = {
  name: "c19z1w",
  styles: "left:50%;"
};
var _ref2 = {
  name: "t7a3hj",
  styles: "left:50%;transform:translateX(-50%);"
};
var _ref3 = {
  name: "rlehus",
  styles: "right:50%;"
};
export var popoutWrapper = _ref4 => {
  var align = _ref4.align;
  return /*#__PURE__*/css("position:absolute;top:100%;", align === 'left' && _ref, " ", align === 'centre' && _ref2, " ", align === 'right' && _ref3);
};